import { lazy } from "react";

const CHUNK_RELOAD_KEY = "v360_chunk_load_reload_at";
const CHUNK_RELOAD_COOLDOWN_MS = 30000;

export const isChunkLoadError = (error) => {
  if (!error) return false;
  const message = String(error?.message || error || "");
  return (
    error?.name === "ChunkLoadError" ||
    /Loading chunk [\d]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message)
  );
};

export const shouldAutoReloadForChunkError = () => {
  try {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (Date.now() - last < CHUNK_RELOAD_COOLDOWN_MS) {
      return false;
    }
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    return true;
  } catch (_e) {
    return false;
  }
};

/**
 * React.lazy wrapper that retries once on ChunkLoadError, then triggers a
 * one-shot full reload (cooldown-gated) so stale deploy hashes recover.
 */
export const lazyWithRetry = (importFn, _chunkLabel = "unknown") =>
  lazy(async () => {
    try {
      return await importFn();
    } catch (firstError) {
      if (!isChunkLoadError(firstError)) {
        throw firstError;
      }

      try {
        return await importFn();
      } catch (retryError) {
        if (
          shouldAutoReloadForChunkError() &&
          typeof window !== "undefined"
        ) {
          window.location.reload();
          return new Promise(() => {});
        }
        throw retryError;
      }
    }
  });
